import React from 'react';
import './WhyAcademy.css';

const reasons = [
  {
    icon: '▶️',
    title: 'Learn from YouTube',
    description: 'Access curated YouTube content organized by departments and skills, making it easy to find relevant learning materials.',
  },
  {
    icon: '📜',
    title: 'Earn Certificates',
    description: 'Complete courses and assessments to earn certificates that demonstrate your skills and expertise.',
  },
  {
    icon: '🗺️',
    title: 'Structured Learning Paths',
    description: 'Follow department-specific learning paths designed to help you grow in your role and advance your career.',
  }
];

const WhyAcademy = () => {
  return (
    <div className="why-academy">
      <h2>Why CriticalRiver Academy?</h2>
      <div className="wa-reasons">
        {reasons.map(reason => (
          <div className="wa-card" key={reason.title}>
            <div className="wa-icon">{reason.icon}</div>
            <h3>{reason.title}</h3>
            <p>{reason.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WhyAcademy;
